import React from 'react';
import cx from 'clsx';
import { ProductDiscount } from '@printdeal/product-selector';
import { useSelector } from 'react-redux';
import { Badge } from '@printdeal/ui-library';
import { FormattedMessage } from 'react-intl';
import { isCustomerProgramReseller, useSegmentation } from '@printdeal/segmentation/react';
import { Experiment } from '@printdeal/feature-management/react';
import { useProductDiscounts } from '../../../hooks/query/useProductDiscounts';
// @ts-expect-error
import { selectors as customerSelectors } from '../../../store/slices/customerSlice';

interface Props {
  productKey: string;
  productDiscounts: ProductDiscount[];
}

export const DiscountLabels = ({ productKey, productDiscounts }: Props) => {
  const { data: segmentationData } = useSegmentation();
  const customerGroupId: string = useSelector(customerSelectors.getCustomerGroupId);

  const isReseller = isCustomerProgramReseller(segmentationData?.isReseller, segmentationData?.isPartOfCustomerProgram);

  const discounts = useProductDiscounts({
    productKey,
    quantity: 1,
    centAmount: 100,
    customerGroupId,
  }, Boolean(customerGroupId && isReseller));

  const resellerDiscount = discounts.data?.find(({ tags }) => tags.includes('reseller'));
  const hasProductDiscounts = productDiscounts.length > 0;
  const hasResellerDiscount = isReseller && resellerDiscount;

  return (
    <section className={cx({ 'pd-mt-4 pd-mb-8 pd-flex pd-flex-col pd-items-start pd-gap-3 md:pd-flex-row md:pd-items-center': hasResellerDiscount || hasProductDiscounts })}>
      {hasProductDiscounts && (
        <Badge variant="warning">
          <FormattedMessage
            id="product.discount"
            defaultMessage="{percentage} % discount"
            values={{ percentage: productDiscounts[0].discountValue.percentage }}
          />
        </Badge>
      )}
      {hasResellerDiscount && (
        <Experiment id="exp1741_partner_pro_label_above_fold">
          <Experiment.Variant>
            <div className="pd-flex pd-items-center pd-gap-3">
              <Badge variant="warning">
                <FormattedMessage
                  id="general.discounts.reseller.discount.labelText"
                  defaultMessage="Partner pro active"
                />
              </Badge>
              {discounts.status === 'success' && (
                <FormattedMessage
                  id="general.discounts.reseller.discount.shippingText"
                  defaultMessage="{percentage}% discount, free shipping and white-label shipping"
                  values={{ percentage: resellerDiscount.discountValue.percentage }}
                />
              )}
            </div>
          </Experiment.Variant>
        </Experiment>
      )}
    </section>
  );
};
